import { render, staticRenderFns } from "./VerPersona.vue?vue&type=template&id=28fb2ce3"
import script from "./VerPersona.vue?vue&type=script&lang=js"
export * from "./VerPersona.vue?vue&type=script&lang=js"
import style0 from "./VerPersona.vue?vue&type=style&index=0&id=28fb2ce3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports